import styled, { keyframes } from "styled-components"

const pointAnimation = keyframes`
    0% {
        opacity: 0;
        top: calc(100vh * (30 / 812));
    }

    100% {
        opacity: 1;
        top: calc(100vh * (10 / 812));
    }
`

export const FullScreen = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  z-index: ${({ zIndex }) => (zIndex ? zIndex : 500)};
`

export const WhiteBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: calc(100vw * (272 / 375));
  // height: calc(100vh * (337 / 812));
  border-radius: calc(100vw * (9 / 375));
  background: #fff;
  padding: calc(100vh * (19 / 812)) calc(100vw * (20 / 375));
`

export const HeaderImgBlock = styled.div`
  width: calc(100vw * (172 / 375));
  margin: 0 auto;
`

export const HeaderImg = styled.img`
  width: 100%;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
  object-fit: cover;
`

export const TitleBlock = styled.div`
  width: 100%;
  text-align: center;
  margin-top: calc(100vh * (23 / 812));
`

export const Title = styled.h3`
  font-weight: 700;
  font-size: calc(100vw * (18 / 375));
  line-height: calc(100vw * (24 / 375));
  color: #121212;
`

export const DescriptionBlock = styled.div`
  width: 100%;
  text-align: center;
  margin-top: calc(100vh * (15 / 812));
`

export const Description = styled.p`
  font-weight: 400;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (20.27 / 375));
  white-space: pre-wrap;
  color: #4e4e4e;
`

export const ButtonBlock = styled.div`
  width: 100%;
  margin-top: calc(100vh * (20 / 812));
  z-index: 30;
`

export const Button = styled.button`
  background: #ffcf19;
  border-radius: calc(100vw * (5 / 375));
  width: 100%;
  padding: calc(100vh * (17 / 812)) 0;
  text-align: center;
  font-weight: 700;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (23 / 375));
`

export const PointBlock = styled.div`
  position: relative;
  margin-top: calc(100vw * (8 / 375));
  text-align: center;
  height: calc(100vw * (19 / 375));
`

export const Point = styled.p`
  position: absolute;
  top: calc(100vw * (10 / 375));
  left: 50%;
  transform: translate(-50%, 0);
  font-size: calc(100vw * (20 / 375));
  font-weight: 700;
  letter-spacing: calc(100vw * (3 / 375));
  line-height: calc(100vw * (20 / 375));
  color: #ffc036;
  opacity: 1;
  animation: ${pointAnimation} 1s;
`
